module.exports = __webpack_public_path__ + "img/cooperate_qy_03@2x.33a7dd36.png";